import React, {useState} from 'react'

import PropTypes from 'prop-types'

import {Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger} from '@chakra-ui/react'
import Field from '/overrides/app/components/field'
import PasswordRequirements from './password-requirements'
import useRegistrationFields from '/overrides/app/components/forms/useRegistrationFields'
import {Box, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

const PaymentRegistrationFields = ({form, prefix = ''}) => {
    const fields = useRegistrationFields({form, prefix})
    const [isOpen, setIsOpen] = useState(false)
    const password = form.watch('password')

    const {tSubscriptions} = useTranslationHelpers()

    return (
        <Stack spacing={5} w="full">
            <Stack spacing={2}>
                {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
                <Popover isLazy isOpen={isOpen} placement="top-start" autoFocus={false}>
                    <PopoverTrigger>
                        <Box>
                            <Field
                                {...fields.password}
                                label=""
                                inputProps={{
                                    placeholder: tSubscriptions?.createPasswordLabel,
                                    onFocus: () => {
                                        setIsOpen(true)
                                        form.clearErrors()
                                    },
                                    onBlur: () => {
                                        setIsOpen(false)
                                        if (password.length) form.trigger()
                                    }
                                }}
                            />
                        </Box>
                    </PopoverTrigger>
                    <PopoverContent>
                        <PopoverArrow />
                        <PopoverBody>
                            <Stack padding={4}>
                                <PasswordRequirements value={password} />
                            </Stack>
                        </PopoverBody>
                    </PopoverContent>
                </Popover>
            </Stack>
        </Stack>
    )
}

PaymentRegistrationFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default PaymentRegistrationFields
